import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LibraryTabs } from "@/components/library-tabs";

/**
 * Pathless layout of the library page and the author, series, tag and publisher pages: it adds the
 * Library section tabs above them without changing any URL.
 */
export const Route = createFileRoute("/_app/_library")({
  component: LibraryLayout,
});

function LibraryLayout() {
  return (
    <div className="grid gap-6">
      <LibraryTabs />
      <Outlet />
    </div>
  );
}
